export const MAP_LANDMARKS_EDIT_CREATE_GROUP_OPEN_MODAL = "MAP_LANDMARKS_EDIT_CREATE_GROUP_OPEN_MODAL";

export const MAP_LANDMARKS_GET_LANDMARK_GROUP = "MAP_LANDMARKS_GET_LANDMARK_GROUP";
export const MAP_LANDMARKS_GET_LANDMARK_GROUP_RESPONSE = "MAP_LANDMARKS_GET_LANDMARK_GROUP_RESPONSE";

export const MAP_LANDMARKS_EDIT_CREATE_LANDMARK_GROUP = "MAP_LANDMARKS_EDIT_CREATE_LANDMARK_GROUP";
export const MAP_LANDMARKS_EDIT_CREATE_LANDMARK_GROUP_RESPONSE = "MAP_LANDMARKS_EDIT_CREATE_LANDMARK_GROUP_RESPONSE";